import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce5d228e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow arrow-top" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.backToTopButtonShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "arrow-wrapper",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToTop()))
        }, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}